<template>
  <div>
    <breadcrumb>
      <template v-slot:1
        ><router-link :to="{ name: 'configuracion-carta' }">{{
          $t("configuracionCarta")
        }}</router-link></template
      >
      <template v-slot:2>{{ $t("idiomas") }}</template>
    </breadcrumb>

    <div class="col-md-12">
        <div class="card">
          <div class="row">
            <div class="col-sm-5 col-md-3">
              <div class="form-group">
                <label for="listBusiness"
                  ><strong>{{ $t("negocio") }}</strong></label
                >

                <el-select
                  class="select-default"
                  size="large"
                  v-model="idBusiness"
                  filterable
                  @change="getTpv()"
                  :placeholder="this.$i18n.t('seleccionaNegocio')"
                >
                  <el-option
                    v-for="business in listBusinesses"
                    class="select-primary"
                    :value="business.id"
                    :label="business.establishmentName"
                    :key="business.id + ' ' + business.establishmentName"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
        </div>
      </div>

    <div class="col-md-12">
      <div class="mt-2" style="display: flex;flex-wrap: wrap;" v-if="permisos && listaIdiomas.length > 0">
            <div class="col-12">
              <span><small><sup>1</sup> {{ $t('idiomasCartaTip1')}}</small></span>
              <br>
              <span><small><sup>2</sup> {{$t('idiomasCartaTip2')}}</small></span>
              <span><small>{{$t('idiomasCartaTip3')}}</small></span>
            </div>
            <div class="card mr-1 mt-3 mb-1 d-inline col-md-3 col-sm-12" style="text-transform:capitalize;" v-for="idioma in listaIdiomas" :key="idioma.id + ' idio'">
              <div class="col-md-9 col-sm-12">
              <img style="width: 25px" class="mr-2" :src="getFlag(idioma.iso_code)"/>
              {{ idioma.name }}
              </div>
              <div class="col-md-12 col-sm-12" id="idiomas">
                <span class="label">Orden:</span> <el-input-number v-model="idioma.orden" controls-position="right" @change="actualizarIdioma(idioma)" :min="0"></el-input-number>
                <VueToggles
                    id="switchIdioma"
                    @click="idioma.activo = !idioma.activo; actualizarIdioma(idioma)"
                    :value="idioma.activo"
                    height="25"
                    fontSize="14"
                    width="50"
                    fontWeight="bold"
                    :checkedText="''"
                    :uncheckedText="''"
                    checkedBg="#28a745"
                    uncheckedBg="lightgrey"
                  ></VueToggles>
              </div>
            </div>
      </div>
      <div v-else>
        <div class="col-md-12">
          <div class="alert alert-danger" role="alert">
            <span>{{$t('permisoControlIdiomas')}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Loading, ColorPicker, Select, Option } from "element-ui";
import { VueToggles } from "vue-toggles";
import Breadcrumb from "@/components/Breadcrumb/Breadcrumb.vue";
import CabeceraInformes from "../../../../../components/CabeceraInformes/CabeceraInformes.vue";
import swal from "sweetalert2";
export default {
  name: "ZonasCarta",
  components: {
    Breadcrumb,
    CabeceraInformes,
    ColorPicker,
    [Select.name]: Select,
    [Option.name]: Option,
  },
  data() {
    return {
      loading: null,
      listBusinesses: [],
      idsTPV: [],
      listTpv: [],
      idBusiness: 0,
      idTpv: 0,
      screen: "",
      inProgress: false,
      permisos: false,
      listaIdiomas: [],
    };
  },
  methods: {
    getFlag(code) {
      
      let url = "";

      switch(code) {
        case 'es':
          url = require('@/assets/img/es.svg');
          break;
        case 'eu':
          url = require('@/assets/img/eu.svg');
          break;
        case 'en':
          url = require('@/assets/img/en.svg');
          break;
        case 'pt':
          url = require('@/assets/img/pt.svg');
          break;
        case 'de':
          url = require('@/assets/img/de.svg');
          break;
        case 'it':
          url = require('@/assets/img/it.svg');
          break;
        case 'fr':
          url = require('@/assets/img/fr.svg');
          break;
        case 'ca':
          url = require('@/assets/img/ca.svg');
          break;
        
        default:
          url = require('@/assets/img/globe.svg');;
          break;
      }

      return url;
    },
    actualizarIdioma(idioma) {
      this.loading = Loading.service({ text: "Cargando..." });
      var config = {
        params: {
          idBusiness: this.idBusiness,
          idioma: idioma,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      var params = {
        idBusiness: this.idBusiness,
        idioma: idioma,
        jwt: this.$store.getters.jwt
      };

      let vm = this;
      this.axios
        .post(this.$store.getters.apiUrl + "delivery/actualizarIdioma", params, config)
        .then(function(response) {
          if (response.data.response) {

            vm.$notify({
              message:
                vm.$t("idioma") +
                " " +
                vm.$t("actualizado") +
                " " +
                vm.$t("correctamente"),
              icon: "nc-icon nc-check-2",
              timeout: 2000,
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success",
            });

            vm.getIdiomasCarta();
          }
        })
        .catch(function(error) {
          console.log(error);
        }).finally((_) => {
          vm.loading.close();
        });
    },
    getIdiomasCarta() {
      this.loading = Loading.service({ text: "Cargando..." });
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "delivery/getIdiomasCarta", config)
        .then(function(response) {
          if (response.data.response) {
            vm.listaIdiomas = response.data.result;
          }
        })
        .catch(function(error) {
          console.log(error);
        }).finally((_) => {
          vm.loading.close();
        });
    },
    getConfigTpv() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          idTpv: this.idTpv,
          jwt: this.$store.getters.jwt,
          numConfig: 38,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getConfigTpv", config)
        .then(function(response) {
          if (response.data.response) {
            vm.permisos = true;

            vm.getIdiomasCarta();
          } else {
            vm.permisos = false;
            vm.loading.close();
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getBusiness() {
      
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
        .then(function(response) {
          if (vm.$store.getters.idBusiness) {
            vm.idBusiness = vm.$store.getters.idBusiness;
          } else {
            vm.idBusiness = response.data.result[0].id;
          }
          vm.listBusinesses = response.data.result;
          vm.getTpv();
        })
        .catch(function(error) {
          console.log(error);
        })

    },
    cambioBusiness(idBusinessData, listTpv) {
      
      this.listaIdiomas = [];
      this.idTpv = 0;
      this.idBusiness = idBusinessData;

      this.getIdiomasCarta();
      this.getTpv();
    },
    emitirConsulta() {},
    cambioTpv(idTpvData) {
      this.idTpv = idTpvData;
    },
    getTpv() {
      this.loading = Loading.service({ text: "Cargando..." });
      this.listTpv = [];
      
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getTpvsByBusiness", config)
        .then(function(response) {
          if (response.data.response) {
            vm.listTpv = response.data.result;

            if (vm.listTpv.length > 0) {
              vm.idTpv = vm.listTpv[0].id;
            }

            vm.getConfigTpv();
            
          } else {
            vm.loading.close();
          }
        })
        .catch(function(error) {
          console.log(error);
        })
    },
  },
  created() {
    
    this.loading = Loading.service({ text: "Cargando..." });
    this.getBusiness();
  },
};
</script>
<style lang="css">
#idiomas .el-input-number {
    
  width: 100px !important;

}
#switchIdioma {
  margin-top: 2%;
  float: right;
}
</style>
<style lang="scss" scoped>
#idiomas {
  margin-top: 5%;
}
body {
  background: #222;
}
h3 {
  margin: 4px 0;
  padding: 5px 0;
  font-family: arial, sans-serif;
  width: 100%;
  color: #fff;
}
a li {
  color: #111;
}
a {
  font-family: arial, sans-serif;
  color: #00b2ee;
  text-decoration: none;
}
#map-canvas {
  width: auto;
  height: 500px;
}
#info {
  color: #222;
}
#clipboard-btn {
  float: left;
  margin-right: 10px;
  padding: 6px 8px;
}
#info {
  height: 140px;
  float: left;
  margin-bottom: 30px;
  border: solid 2px #eee;
}
#info,
.lngLat {
  font-family: arial, sans-serif;
  font-size: 12px;
  padding-top: 10px;
  width: 270px;
}

.card {
  padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Delivery/Configuracion/Idiomas/IdiomasCarta.vue